import TransformsPage from '@/views/transforms/TransformsPage.vue';
import { Permissions } from '@/utils/constants';
import TransformDetailsPage from '@/views/transforms/TransformDetailsPage.vue';
import CreateTransform from '@/views/transforms/CreateTransform.vue';
import CreateTransformType from '@/views/transforms/CreateTransformType.vue';

export default [
    {
        path: '/transforms',
        name: 'transforms',
        component: TransformsPage,
        meta: {
            title: 'Transforms',
            breadcrumbLabel: 'Transforms',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_TRANSFORMS, Permissions.READ_TRANSFORM_METRICS], // write is not required to see the page and will hide the action buttons if needed
                    type: 'and'
                }
            }
        }
    },
    {
        path: '/transforms/create',
        name: 'create-transform',
        component: CreateTransform,
        meta: {
            title: 'Create Transform',
            breadcrumbLabel: 'Select Type',
            breadcrumbParent: 'transforms',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.WRITE_TRANSFORMS],
                    type: 'or'
                }
            }
        }
    },
    {
        path: '/transforms/create/:transformType',
        name: 'create-transform-type',
        component: CreateTransformType,
        props: (route) => ({
            transformType: route.params.transformType || null
        }),
        meta: {
            title: 'Create Transform',
            breadcrumbLabel: (route) => (route.params.transformType ? `Create ${route.params.transformType}` : 'Create'),
            breadcrumbParent: 'create-transform',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.WRITE_TRANSFORMS]
                }
            }
        }
    },
    {
        path: '/transforms/view/:id',
        name: 'transform-details',
        props: (route) => ({
            id: route.params.id
        }),
        component: TransformDetailsPage,
        meta: {
            title: 'Transform Details',
            breadcrumbParent: 'transforms',
            requireAuth: true,
            accessRules: {
                permissions: {
                    values: [Permissions.READ_TRANSFORMS, Permissions.READ_TRANSFORM_METRICS], // write is not required to see the page and will hide the action buttons if needed
                    type: 'and'
                }
            }
        }
    }
];
